/**
 * API Client Utility — shared helpers for authenticated API calls.
 */

const API_BASE = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8787'

/**
 * Get auth headers including JWT Bearer token.
 */
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('lamoney-token')
  if (token) {
    return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
  }
  return { 'Content-Type': 'application/json' }
}

/**
 * Get auth headers without Content-Type (for GET requests).
 */
export function getAuthFetchHeaders(): Record<string, string> {
  const token = localStorage.getItem('lamoney-token')
  if (token) {
    return { 'Authorization': `Bearer ${token}` }
  }
  return {}
}

/**
 * Authenticated GET request.
 */
export async function apiGet<T = any>(path: string): Promise<T | null> {
  try {
    const res = await fetch(`${API_BASE}${path}`, { headers: getAuthFetchHeaders() })
    if (res.status === 401) {
      console.warn('Auth expired — redirect to login')
      return null
    }
    if (res.ok) return await res.json()
    return null
  } catch {
    return null
  }
}

/**
 * Authenticated POST/PUT/DELETE request.
 */
export async function apiMutate<T = any>(
  path: string,
  method: 'POST' | 'PUT' | 'DELETE' = 'POST',
  body?: any,
): Promise<T | null> {
  try {
    const opts: RequestInit = { method, headers: getAuthHeaders() }
    if (body !== undefined) opts.body = JSON.stringify(body)
    const res = await fetch(`${API_BASE}${path}`, opts)
    if (res.status === 401) {
      console.warn('Auth expired')
      return null
    }
    if (res.ok) return await res.json()
    return null
  } catch {
    return null
  }
}

export { API_BASE }
